import styled from "styled-components";

export const DialogSubtitle = styled.div`
    margin-top: 10px;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    color: #666666;
    p + p {
        margin-top: 10px;
    }
`;
